import { MarketingLayout } from "../../components/marketing/marketing-layout";
import { comingSoonContent } from "../../content/marketing/coming-soon";
import { usePageMeta } from "../../hooks/use-page-meta";

export default function ComingSoonPage() {
  usePageMeta(comingSoonContent.metaTitle, comingSoonContent.metaDescription);

  return (
    <MarketingLayout>
      <section className="mx-auto flex max-w-[65ch] flex-col gap-4 px-4 py-16 text-center md:px-6 md:py-24">
        <h1 className="font-bold font-display text-3xl md:text-4xl">
          {comingSoonContent.heading}
        </h1>
        <p className="text-base text-muted-foreground">
          {comingSoonContent.intro}
        </p>
      </section>

      <section className="mx-auto max-w-3xl px-4 pb-16 md:px-6 md:pb-24">
        <div className="flex flex-col gap-6">
          {comingSoonContent.items.map((item) => (
            <div
              className="rounded-lg border border-border p-6"
              key={item.title}
            >
              <h3 className="font-semibold text-lg">{item.title}</h3>
              <p className="mt-1 text-muted-foreground text-sm">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </section>
    </MarketingLayout>
  );
}
